import { COMMON_METRICS } from './columns';

export const buildBaseMetricsBundle = (translate: (key: string) => string) => {
let custom: { [type: string]: Bemob.MetricsHelpAggregated } = {};
    let customWeights: { [type: string]: number } = {};

    for(let i = 1; i <= 10; i++) {
      const customKey: string = 'reports-custom' + i;
      const customKeyMasked: string = `reports-custom${i}masked`;
      const trafficSourcesKey: string = `traffic_sources-custom${i}param`;

      custom[trafficSourcesKey] = {
        short: translate('Parameter for passing additional traffic data'),
        full: translate('Parameter from traffic source settings which is used to pass the additional details on traffic data.')
      }

      custom[customKey] = {
        short: translate('Parameter for passing additional traffic data'),
        full: translate('Parameter from traffic source settings which is used to pass the additional details on traffic data.')
      }

      custom[customKeyMasked] = {
        short: translate('Masked value of custom parameter'),
        full: translate('Masked value of the corresponding parameter of traffic source.')
      }

      customWeights[customKey] = customWeights[trafficSourcesKey] = 100;
    }

    return {
      avaliable_metrics: [],
      default_omit: COMMON_METRICS.defaultUnselected,
      default_include: COMMON_METRICS.defaultSelected,
      default_sort: COMMON_METRICS.defaultSort,
      metrics_filters: COMMON_METRICS.filters,
      report_exclude: COMMON_METRICS.exclude,
      metrics_help:{
        'campaigns-name': {
          short: translate('Name of the campaign'),
          full: translate('The campaign name is based on selected traffic source, country tag and unique custom name. Name preferences should be set up in Settings -> General -> Reporting.')
        },
        'campaigns-url': {
          short: translate('Link of your ad campaign'),
          full: translate('Unique campaign link which should be added on the side of your traffic source. This URL redirects a visitor of your ad campaign to a landing page or an offer link set in BeMob.')
        },
        'campaigns-externalstatus': {
          short: translate('Status of the campaign received from a traffic source'),
          full: translate('Status of the campaign received from a traffic source.')
        },
        'campaigns-externalid': {
          short: translate('Unique ID assigned to a campaign on the side of a traffic source'),
          full: translate('Unique ID assigned to a campaign on the side of a traffic source.')
        },
        'workspaces-name': {
          short: translate('Custom name of the workspace'),
          full: translate('Name of workspace to which the element belongs.')
        },
        'campaigns-id': {
          short: translate('Unique ID of campaign'),
          full: translate('The unique ID is assigned to each campaign in tracker. This ID will be displayed in the campaign URL.')
        },
        'campaigns-created': {
          short: translate('Timestamp of element creation'),
          full: translate('Timestamp of element creation')
        },
        'campaigns-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change')
        },
        'campaigns-updatedby': {
          short: translate('Name of User who introduced the latest changes'),
          full: translate('Name of User who introduced the latest changes')
        },
        'campaigns-countryid': {
          short: translate('Name of country'),
          full: translate('Country selected in campaign settings.')
        },
        'campaigns-trafficsourceid': {
          short: translate('Name of traffic source'),
          full: translate('Platform which generates traffic for the campaign.')
        },
        'campaigns-costmodel': {
          short: translate('Model selected in campaign settings'),
          full: translate('Model which defines how the payment for traffic is organized with the traffic source.')
        },
        'campaigns-costvalue': {
          short: translate('Amount of money paid for traffic'),
          full: translate('Indicates the fixed value paid to the traffic source according to cost model selected.')
        },
        'reports-impressions': {
          short: translate('Impressions amount for selected period'),
          full: translate('An impression is registered each time the dedicated impression pixel loads along with your ad banner.')
        },
        'reports-impressionsuniq': {
          short: translate('Unique impressions for selected period'),
          full: translate('Shows the number of impressions registered for a campaign within specified uniqueness period.')
        },
        'reports-impressionsbot': {
          short: translate('Bot impressions for selected period'),
          full: translate('Indicates the amount of impressions considered as suspicious according to the bot rules.')
        },
        'reports-visits': {
          short: translate('Visits amount for selected period'),
          full: translate('A visit is registered each time the Campaign URL is accessed.')
        },
        'reports-visitsuniq': {
          short: translate('Unique visits for selected period'),
          full: translate('Shows the number of visits registered for a campaign within specified uniqueness period.')
        },
        'reports-visitsbot': {
          short: translate('Bot visits for selected period'),
          full: translate('Indicates the amount of visits considered as suspicious according to the bot rules.')
        },
        'reports-clicks': {
          short: translate('Clicks amount for selected period'),
          full: translate('A click is registered each time when the CTA button on the landing page is clicked.')
        },
        'reports-clicksuniq': {
          short: translate('Unique clicks for selected period'),
          full: translate('Shows the number of clicks registered for a campaign within specified uniqueness period.')
        },
        'reports-clicksbot': {
          short: translate('Bot clicks for selected period'),
          full: translate('Indicates the amount of clicks considered as suspicious according to the bot rules.')
        },
        'reports-conversionnew': {
          short: translate('New conversions amount'),
          full: translate('New conversion appears each time the postback URL/pixel passes the corresponding value specified in settings of Affiliate Network.')
        },
        'reports-conversionsent': {
          short: translate('Conversions that were sent to the traffic source.'),
          full: translate('Conversions that were sent to the traffic source.')
        },
        'reports-conversions': {
          short: translate('Total conversions amount'),
          full: translate('All the custom conversions and conversions with statuses associated with the campaign or the element for a selected timeframe.')
        },
        'reports-conversionswebview': {
          short: translate('Displays conversions from WebView traffic.'),
          full: translate('Displays conversions from WebView traffic.'),
        },
        'reports-conversionswebviewrevenue': {
          short: translate('Displays the revenue received in the payout parameter for conversions with Click IDs identified by the system as WebView traffic.'),
          full: translate('Displays the revenue received in the payout parameter for conversions with Click IDs identified by the system as WebView traffic.'),
        },
        'reports-conversionconfirm': {
          short: translate('Approved conversions amount'),
          full: translate('Confirmed conversion appears each time the postback URL/pixel passes the corresponding value specified in settings of Affiliate Network.')
        },
        'reports-conversionconfirmhiddenrevenue': {
          short: translate('Revenue of conversions with confirmed status that was not sent to the traffic source.'),
          full: translate('Revenue of conversions with confirmed status that was not sent to the traffic source.')
        },
        'reports-conversionchargerevenue': {
          short: translate('Revenue from conversions with the status “Charged”.<br>Displayed as a negative value.'),
          full: translate('Revenue from conversions with the status “Charged”.<br>Displayed as a negative value.')
        },
        'reports-conversionconfirmrevenue': {
          short: translate('Revenue of conversions with confirmed status.'),
          full: translate('Revenue of conversions with confirmed status.')
        },
        'reports-conversiondecline': {
          short: translate('Declined conversions amount'),
          full: translate('Declined conversion appears each time the postback URL/pixel passes the corresponding value specified in settings of Affiliate Network.')
        },
        'reports-conversioncharge': {
          short: translate('Chargeback conversions for selected period'),
          full: translate('With this status received in tracker, the revenue of conversion will be subtracted from the stats.')
        },
        'reports-revenue': {
          short: translate('Registered number of conversions * Payout'),
          full: translate('Shows the payout value received for a successful conversion.')
        },
        'reports-hiddenrevenue': {
          short: translate('Revenue - Revenue of conversions sent to the traffic source via postback'),
          full: translate('Shows the revenue of conversions which were not sent to the traffic source when Send Postbacks % option is active.')
        },
        'reports-cost': {
          short: translate('Traffic cost for the selected period'),
          full: translate('Indicates the amount of money paid to the traffic source.')
        },
        'reports-costbot': {
          short: translate('Cost generated by bot traffic.'),
          full: translate('Displays the cost generated by visits identified by the system as bot traffic. The value is part of the total cost, but is recorded in this separate column to help evaluate spending on bot traffic.')
        },
        'reports-profit': {
          short: translate('Revenue - Cost'),
          full: translate('Revenue - Cost. The amount of money earned.')
        },
        'reports-cpc': {
          short: translate('Cost / Clicks'),
          full: translate('Cost / Clicks. Cost of one click.')
        },
        'reports-cpv': {
          short: translate('Cost / Visits'),
          full: translate('Cost/ Visits. Cost of one visit.')
        },
        'reports-ctr': {
          short: translate('Clicks / Visits * 100%'),
          full: translate('Clicks / Visits * 100%. Click-through rate of landing page.')
        },
        'reports-1xctr': {
          short: translate('1 : Visits / Clicks'),
          full: translate('Indicates the number of visits accounted to 1 click.')
        },
        'reports-uctr': {
          short: translate('Unique Сlicks / Unique Visits * 100%'),
          full: translate('Unique Clicks / Unique Visits * 100%. Landing page click-through rate for unique traffic.')
        },
        'reports-cr': {
          short: translate('Conversions / Clicks * 100%'),
          full: translate('Conversions / Clicks * 100%. Conversion rate counted for a campaign with landing page.')
        },
        'reports-1xcr': {
          short: translate('1 : Clicks / Conversions'),
          full: translate('Indicates the number of clicks accounted to 1 conversion.')
        },
        'reports-cv': {
          short: translate('Conversions / Visits * 100%'),
          full: translate('Conversions / Visits * 100%. Conversion rate counted for a campaign with direct linking.')
        },
        'reports-1xcv': {
          short: translate('1 : Visits / Conversions'),
          full: translate('Indicates the number of visits accounted to 1 conversion.')
        },
        'reports-roi': {
          short: translate('(Revenue - Cost) / Cost * 100%'),
          full: translate('Return on investment shows the percentage of the money earned to the money invested.')
        },
        'reports-epv': {
          short: translate('Revenue / Visits'),
          full: translate('Revenue / Visits. Earn per visit')
        },
        'reports-epc': {
          short: translate('Revenue / Clicks'),
          full: translate('Revenue / Clicks. Earn per click.')
        },
        'reports-ap': {
          short: translate('Revenue / Conversions'),
          full: translate('Revenue / Conversions. Average price of a conversion.')
        },
        'offers-name': {
          short: translate('Name of offer'),
          full: translate('The offer name is based on country tag and unique custom name. Name preferences for offer name in report should be set up in Settings -> General -> Reporting.')
        },
        'offers-id': {
          short: translate('Unique ID of offer'),
          full: translate('Unique ID assigned to the offer in tracker.')
        },
        'offers-url': {
          short: translate('Link of offer'),
          full: translate('Link provided by affiliate network or direct advertizer.')
        },
        'offers-countryid': {
          short: translate('Name of country'),
          full: translate('Country selected in offer settings.')
        },
        'offers-payout': {
          short: translate('Expected revenue for conversion'),
          full: translate('Value specified in offer settings with manual payout tracking selected.')
        },
        'offers-affiliatenetworkid': {
          short: translate('Network associated with offer'),
          full: translate('Affiliate network is a platform which contains multiple offers on various niches.')
        },
        'offers-created': {
          short: translate('Timestamp of element creation'),
          full: translate('Timestamp of element creation')
        },
        'offers-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change')
        },
        'offers-updatedby': {
          short: translate('Name of User who introduced the latest changes'),
          full: translate('Name of User who introduced the latest changes')
        },
        'landings-name': {
          short: translate('Name of the landing page'),
          full: translate('The  landing page name is based on country tag and unique custom name. Name preferences for landing page name in report  should be set up in Settings -> General -> Reporting.')
        },
        'landings-id': {
          short: translate('Unique ID of landing page'),
          full: translate('The unique ID is assigned to each landing page in tracker.')
        },
        'landings-url': {
          short: translate('Link of the landing page'),
          full: translate('URL of landing page which is an externally hosted web page which contains CTA links or buttons that lead to the offer page.')
        },
        'landings-countryid': {
          short: translate('Name of country'),
          full: translate('Country selected in landing page settings.')
        },
        'landings-offers': {
          short: translate('Number of offers'),
          full: translate('Number of offers should match the number of click URLs placed on landing page code.')
        },
        'landings-created': {
          short: translate('Timestamp of element creation'),
          full: translate('Timestamp of element creation')
        },
        'landings-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change')
        },
        'landings-updatedby': {
          short: translate('Name of User who introduced the latest changes'),
          full: translate('Name of User who introduced the latest changes')
        },
        'flows-name': {
          short: translate('Name of flow'),
          full: translate('The  flow name is based on country tag, custom name and the date and time of flow creation. Name preferences for flow name in report should be set up in Settings -> General -> Reporting.')
        },
        'flows-id': {
          short: translate('Unique ID of flow'),
          full: translate('Unique ID assigned to the flow in tracker.')
        },
        'flows-created': {
          short: translate('Timestamp of element creation'),
          full: translate('Timestamp of element creation')
        },
        'flows-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change')
        },
        'flows-updatedby': {
          short: translate('Name of User who introduced the latest changes'),
          full: translate('Name of User who introduced the latest changes')
        },
        'flows-offersAmount': {
          short: translate('Number of offers'),
          full: `${translate('Number of offers added in the flow')}.`,
        },
        'flows-landingsAmount': {
          short: translate('Number of landings'),
          full: `${translate('Number of landings added in the flow')}.`,
        },
        'traffic_sources-name': {
          short: translate('Official or custom name of traffic source'),
          full: translate('If traffic source is added from the template, the name will be pre-filled with the official name of traffic source. Also custom name can be added in traffic source settings.')
        },
        'traffic_sources-id': {
          short: translate('Unique ID of traffic source'),
          full: translate('The unique ID is assigned to each traffic source in tracker.')
        },
        'traffic_sources-postbackurl': {
          short: translate('Dedicated traffic source URL'),
          full: translate('Dedicated URL of traffic source for conversions passing from tracker to the side of traffic source.')
        },
        'traffic_sources-extclickidparam': {
          short: translate('Traffic source parameter for click ID'),
          full: translate('Parameter from traffic source settings which is used to pass the unique click identifier from traffic source to tracker.')
        },
        'traffic_sources-costparam': {
          short: translate('Traffic source parameter for cost'),
          full: translate('Cost parameter is required to pass the cost data from traffic source to the tracker through dedicated parameter.')
        },
        'traffic_sources-created': {
          short: translate('Timestamp of element creation'),
          full: translate('Timestamp of element creation')
        },
        'traffic_sources-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change')
        },
        'traffic_sources-updatedby': {
          short: translate('Name of User who introduced the latest changes'),
          full: translate('Name of User who introduced the latest changes')
        },
        'affiliate_networks-name': {
          short: translate('Official or custom name of affiliate network'),
          full: translate('If affiliate network is added from the template, the name will be pre-filled with the official name of affiliate network. Also custom name can be added in affiliate network settings.')
        },
        'affiliate_networks-id': {
          short: translate('Unique ID of affiliate network'),
          full: translate('Unique ID assigned to the affiliate network in tracker.')
        },
        'affiliate_networks-appendclickid': {
          short: translate('Parameter for passing click ID automatically'),
          full: translate('This parameter allows to add the click ID parameter of affiliate network and the dedicated BeMob token {clickId} at the end of each offer URL associated with this affiliate network.')
        },
        'affiliate_networks-postbackonlywhiteips': {
          short: translate('Allows to avoid postbacks from untrusted IPs'),
          full: translate('The option is required to receive the postback requests from trusted IPs only.')
        },
        'affiliate_networks-created': {
          short: translate('Timestamp of element creation'),
          full: translate('Timestamp of element creation')
        },
        'affiliate_networks-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change')
        },
        'affiliate_networks-updatedby': {
          short: translate('Name of User who introduced the latest changes'),
          full: translate('Name of User who introduced the latest changes')
        },
        'reports-language': {
          short: translate('Name of language'),
          full: translate('Language of visitor’s browser.')
        },
        'reports-city': {
          short: translate('Name of city'),
          full: translate('Name of city the report is based on.')
        },
        'reports-state': {
          short: translate('Name of state or region'),
          full: translate('Name of state or region the report is based on.')
        },
        'reports-country': {
          short: translate('Name of country'),
          full: translate('Name of country the report is based on.')
        },
        'reports-isp': {
          short: translate('Internet Service Provider'),
          full: translate('Internet Service Provider the report is based on.')
        },
        'reports-mobilecarrier': {
          short: translate('Name of mobile carrier'),
          full: translate('Mobile carrier of device the report is based on.')
        },
        'reports-connecttype': {
          short: translate('Name of connection type'),
          full: translate('Connection type the report is based on.')
        },
        'reports-devicemodel': {
          short: translate('Name of device model'),
          full: translate('Model of device the report is based on.')
        },
        'reports-devicevendor': {
          short: translate('Name of device vendor'),
          full: translate('Vendor of device the report is based on.')
        },
        'reports-devicetype': {
          short: translate('Name of device type'),
          full: translate('Type of device the report is based on.')
        },
        'reports-screenresolution': {
          short: translate('Width × height of the device screen'),
          full: translate('Screen resolution the report is based on.')
        },
        'reports-os': {
          short: translate('Operating system name'),
          full: translate('Operating system the report is based on.')
        },
        'reports-osversion': {
          short: translate('Operating system version name'),
          full: translate('Version of operating system the report is based on.')
        },
        'reports-browser': {
          short: translate('Name of browser'),
          full: translate('Name of browser the report is based on.')
        },
        'reports-browserversion': {
          short: translate('Version of browser data'),
          full: translate('Version of browser the report is based on.')
        },
        'useragents-useragent': {
          short: translate('User agent of visitor’s browser'),
          full: translate('User agent data the report is based on.')
        },
        'ips-ip': {
          short: translate('IP address'),
          full: translate('IP address the report is based on.')
        },
        'reports-subnetsmall': {
          short: translate('Small subdivisions of IP address'),
          full: translate('Small subdivision of IP address the report is based on.')
        },
        'reports-subnetbig': {
          short: translate('Big subdivisions of IP address'),
          full: translate('Big subdivision of IP address the report is based on.')
        },
        'referrers-referrer': {
          short: translate('Referrer data'),
          full: translate('Referrer the report is based on.')
        },
        'referrer_domains-name': {
          short: translate('Referrer domain data'),
          full: translate('Referrer domain the report is based on.')
        },
        'reports-month': {
          short: translate('Month name'),
          full: translate('The report is based on the selected month of the year.')
        },
        'reports-day': {
          short: translate('Date of the month'),
          full: translate('The report is based on the selected date of the month.')
        },
        'reports-dayofweek': {
          short: translate('Name of the day'),
          full: translate('Day of week the report is based on.')
        },
        'reports-hourofday': {
          short: translate('Day hour'),
          full: translate('Hour of day the report is based on.')
        },
        'reports-impressionswebview': {
          short: translate('Amount of impressions associated with WebView traffic'),
          full: `${translate('Amount of impressions associated with WebView traffic')}.`,
        },
        'reports-visitswebview': {
          short: translate('Amount of visits associated with WebView traffic'),
          full: `${translate('Amount of visits associated with WebView traffic')}.`,
        },
        'reports-clickswebview': {
          short: translate('Amount of clicks associated with WebView traffic'),
          full: `${translate('Amount of clicks associated with WebView traffic')}.`,
        },
        'reports-impressionssuspicious': {
          short: translate('Total amount of impressions considered as suspicious'),
          full: `${translate('Total amount of impressions considered as suspicious')}.`,
        },
        'reports-impressionssuspiciousblacklistedips': {
          short: translate('Impressions that come from the blacklisted IPs'),
          full: `${translate('Impressions that come from the blacklisted IPs')}.`,
        },
        'reports-impressionssuspiciousdatacenterips': {
          short: translate('Impressions that come from the IPs that belong to known data centers'),
          full: `${translate('Impressions that come from the IPs that belong to known data centers')}.`,
        },
        'reports-visitssuspicious': {
          short: translate('Total amount of visits considered as suspicious'),
          full: `${translate('Total amount of visits considered as suspicious')}.`,
        },
        'reports-visitssuspiciousblacklistedips': {
          short: translate('Visits that come from the blacklisted IPs'),
          full: `${translate('Visits that come from the blacklisted IPs')}.`,
        },
        'reports-visitssuspiciousdatacenterips': {
          short: translate('Visits that come from the IPs that belong to known data centers'),
          full: `${translate('Visits that come from the IPs that belong to known data centers')}.`,
        },
        'reports-clickssuspicious': {
          short: translate('Total amount of clicks considered as suspicious'),
          full: `${translate('Total amount of clicks considered as suspicious')}.`,
        },
        'reports-clickssuspiciousblacklistedips': {
          short: translate('Clicks that come from the blacklisted IPs'),
          full: `${translate('Clicks that come from the blacklisted IPs')}.`,
        },
        'reports-clickssuspiciousdatacenterips': {
          short: translate('Clicks that come from the IPs that belong to known data centers'),
          full: `${translate('Clicks that come from the IPs that belong to known data centers')}.`,
        },
        'reports-impressions_suspicious_ip_with_frequent_events': {
          short: translate('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events'),
          full: `${translate('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events')}.`,
        },
        'reports-visits_suspicious_ip_with_frequent_events': {
          short: translate('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events'),
          full: `${translate('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events')}.`,
        },
        'reports-clicks_suspicious_ip_with_frequent_events': {
          short: translate('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events'),
          full: `${translate('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events')}.`,
        },
        'reports-impressions_suspicious_ip_with_frequent_campaign_events': {
          short: translate('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign'),
          full: `${translate('The impressions in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign')}.`,
        },
        'reports-visits_suspicious_ip_with_frequent_campaign_events': {
          short: translate('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign'),
          full: `${translate('The visits in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign')}.`,
        },
        'reports-clicks_fast_clicker': {
          short: translate('The clicks in this column are defined as frequent because they have less than 800 ms between ad visit and the click on CTA button, which can be classified as suspicious behaviour'),
          full: `${translate('The clicks in this column are defined as frequent because they have less than 800 ms between ad visit and the click on CTA button, which can be classified as suspicious behaviour')}.`,
        },
        'reports-clicks_suspicious_ip_with_frequent_campaign_events': {
          short: translate('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign'),
          full: `${translate('The clicks in this column are defined as frequent because they are made from IPs that generate the unusual amount of events within one ad campaign')}.`,
        },
        'reports-cpa': {
          short: translate('Сost / (Сonversions Confirmed + Custom Conversions with Revenue Included) - Conversions With Chargeback'),
          full: translate('Сost / (Сonversions Confirmed + Custom Conversions with Revenue Included) - Conversions With Chargeback. <br>Cost per one conversion.'),
        },
        'reports-hiddenprofit': {
          short: translate('Profit + Hidden Revenue.'),
          full: translate('Profit + Hidden Revenue.<br>Profit data on conversions that have not been sent to the traffic source when the “Send Postbacks %” option is used.'),
        },
        'campaigns-number': {
          short: translate('Serial number of the created campaign.'),
          full: translate('Serial number of the created campaign.')
        },
        'offers-number': {
          short: translate('Serial number of the created offer.'),
          full: translate('Serial number of the created offer.')
        },
        'landings-number': {
          short: translate('Serial number of the created landing page.'),
          full: translate('Serial number of the created landing page.')
        },
        'flows-number': {
          short: translate('Serial number of the flow.'),
          full: translate('Serial number of the flow.')
        },
        'affiliate_networks-number': {
          short: translate('Serial number of the created affiliate network.'),
          full: translate('Serial number of the created affiliate network.')
        },
        'traffic_sources-number': {
          short: translate('Serial number of the created traffic source.'),
          full: translate('Serial number of the created traffic source.')
        },
        'flow_rule_paths-name': {
          short: translate('Flow Path Name'),
          full: translate('Flow Path Name')
        },
        'flow_rule_paths-id': {
          short: translate('Unique ID assigned to the flow path in BeMob'),
          full: translate('Unique ID assigned to the flow path in BeMob')
        },
        'flow_rule_paths-number': {
          short: translate('Serial number of the flow path'),
          full: translate('Serial number of the flow path')
        },
        'flow_rule_paths-directlinking': {
          short: translate('Value “Yes” — the path has no landing page.<br>Value “No” — the path includes landing pages.'),
          full: translate('Value “Yes” — the path has no landing page.<br>Value “No” — the path includes landing pages.')
        },
        'flow_rule_paths-created': {
          short: translate('Timestamp of path creation in UTC'),
          full: translate('Timestamp of path creation in UTC')
        },
        'flow_rule_paths-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change')
        },
        'flow_rule_paths-updatedby': {
          short: translate('Name of member who introduced the latest changes'),
          full: translate('Name of member who introduced the latest changes')
        },
        'flow_rules-name': {
          short: translate('Flow Rule Name'),
          full: translate('Flow Rule Name')
        },
        'flow_rules-id': {
          short: translate('Unique ID assigned to the flow rule in BeMob. If the column is empty, the campaign destination is built-in flow.'),
          full: translate('Unique ID assigned to the flow rule in BeMob. If the column is empty, the campaign destination is built-in flow.')
        },
        'flow_rules-default': {
          short: translate('Value “Yes” — the rule is default for the flow.<br>Value “No” — the rule is not default for the flow.'),
          full: translate('Value “Yes” — the rule is default for the flow.<br>Value “No” — the rule is not default for the flow.'),
        },
        'flow_rules-number': {
          short: translate('Serial number of the flow rule'),
          full: translate('Serial number of the flow rule'),
        },
        'flow_rules-created': {
          short: translate('Timestamp of rule creation in UTC'),
          full: translate('Timestamp of rule creation in UTC'),
        },
        'flow_rules-updated': {
          short: translate('Timestamp of the last change'),
          full: translate('Timestamp of the last change'),
        },
        'flow_rules-updatedby': {
          short: translate('Name of member who introduced the latest changes'),
          full: translate('Name of member who introduced the latest changes'),
        },
        'flow_rule_paths-weight': {
          short: translate('The weight of the path that determines how traffic is distributed within the campaign.'),
          full: translate('The weight of the path that determines how traffic is distributed within the campaign.'),
        },
        ...custom
      },

      metrics_options: {
        ...COMMON_METRICS.weight,
        ...customWeights
      },
      sort_exclude:[
        'campaigns-url',
        'offers-payout'
      ]

    } as Bemob.Metrics
};
